<template>
  <div class="news-and-footer">
    <div class="page_content">
      <h3>ビューティーワールドジャパン2026福岡に出展いたします。</h3>
      <br>

      <div class="news_image">
        <img src="/assets/img/bwf09_outline_cube_L_jp.jpg" alt="ビューティーワールドジャパン2026福岡">
      </div>

      <p>
        昨年発売したばかりの業務用マシンDr-PRO MAXや店販用美容器Dr-PRO BEAUTY SECRET等を実際にお試しいただけます。<br>
        お気軽にご来場ください。
      </p>

      <p>
        会期　　　　：2026年2月16日（月）－18日（水）<br>
        時間　　　　：10:00－17:00（最終日は16:30まで）<br>
        会場　　　　：マリンメッセ福岡A館（〒812-0031 福岡県福岡市博多区沖浜町７−１）<br>
        出展社名　　：株式会社スカンジナビアサービス<br>
        ブース番号　：E-017<br>
      </p>

      <p class="reserve">
        事前予約はこちら：
        <a
          href="https://docs.google.com/forms/d/1dg8De4t5Kx0dz0NrIhrr86d1DWfuaMqzD5DYpWbixxo/edit"
          target="_blank"
          rel="noopener"
        >
          予約フォーム
        </a>
      </p>

      <footer2></footer2>
    </div>
  </div>
</template>

<script>
export default {
  name: 'news20260216',
  components: {
    footer2: () => import('../components/Footer2.vue'),
  },
}
</script>

<style lang="scss" scoped>
.news-and-footer {
  margin-top: 80px;
}

.news_image {
  margin: 10px 0 25px;
}

.news_image img {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 0 auto;
}

.reserve a {
  text-decoration: underline;
}

@media (max-width: 600px) {
  .news-and-footer {
    margin-top: 30px;
  }
}
</style>

